<template>
	<div :class="classes">
		<slot></slot>
	</div>
</template>

<script>
import { Enum } from "@teaming/common-enums";

export const TEAMING_BADGE_STYLE = Enum.create( {
	PRIMARY: "PRIMARY",
	SECONDARY: "SECONDARY",
} );

export const TEAMING_BADGE_SIZE = Enum.create( {
	SMALL: "SMALL",
	MEDIUM: "MEDIUM",
	LARGE: "LARGE",
} );

export default {
	name: "TeamingBadge",
	props: {
		style: {
			type: String,
			default: TEAMING_BADGE_STYLE.PRIMARY,
			validator( value ) {
				return TEAMING_BADGE_STYLE.includes( value );
			},
		},
		size: {
			type: String,
			default: TEAMING_BADGE_SIZE.MEDIUM,
			validator( value ) {
				return TEAMING_BADGE_SIZE.includes( value );
			},
		},
	},
	computed: {
		classes() {
			const { style, size, } = this;
			return {
				"teaming-badge": true,
				"teaming-badge--primary": ( style === TEAMING_BADGE_STYLE.PRIMARY ),
				"teaming-badge--secondary": ( style === TEAMING_BADGE_STYLE.SECONDARY ),
				small: ( size === TEAMING_BADGE_SIZE.SMALL ),
				medium: ( size === TEAMING_BADGE_SIZE.MEDIUM ),
				large: ( size === TEAMING_BADGE_SIZE.LARGE ),
			};
		},
	},
};
</script>

<style lang="scss" scoped>
$primaryColor: $white;
$primaryBackgroundColor: $color1-500;

$secondaryColor: $color1-600;
$secondaryBackgroundColor: $color1-100;

.teaming-badge {
	display: inline-flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: center;
}

.teaming-badge.small {
	@include font-and-line-for(-2);
	text-transform: uppercase;
	padding: 0 0.3125rem; // 0px 5px
	border-radius: 1.5rem; // 24px
}

.teaming-badge.medium {
	@include font-and-line-for(-1);
	padding: 0.125rem 0.5rem; // 2px 8px
	border-radius: 8rem; // 128px
}

.teaming-badge.large {
	@include font-and-line-for(0);
	padding: 0.125rem 0.5rem; // 2px 8px
	border-radius: 8rem; // 128px
}

.teaming-badge--primary {
	color: $primaryColor;
	background-color: $primaryBackgroundColor;
}

.teaming-badge--secondary {
	color: $secondaryColor;
	background-color: $secondaryBackgroundColor;
}
</style>
